
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageMetadata } from '@/data/pageMetadata';
import { updateDocumentTitle, updateMetaDescription, updateCanonicalUrl, updateRobotsTag } from '@/utils/seoUtils';
import { 
  addRockyMountSchema, 
  addGreenvilleSchema, 
  addTarboroSchema, 
  addFAQSchema, 
  addOrganizationSchema 
} from './SchemaManager';

const SEOManager = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Get current page path
    const path = location.pathname;
    
    // Set default metadata with enhanced SEO
    let title = "Carolina Trophy Roofs | #1 Roofing Contractor in Eastern North Carolina";
    let description = "Carolina Trophy Roofs is Eastern NC's premier roofing contractor serving Rocky Mount, Greenville, Wilson, and surrounding areas. Expert residential and commercial roofing services with local offices and 24/7 emergency response.";
    
    // Find matching metadata for current path
    const metadata = pageMetadata[path];
    if (metadata) {
      title = metadata.title;
      description = metadata.description;
    }
    
    // Update document title and meta description
    updateDocumentTitle(title);
    updateMetaDescription(description);
    updateCanonicalUrl(path);
    
    // Only add schema for public-facing pages
    if (!path.includes('Blog-Page-Builder') && !path.includes('admin')) {
      // For home page, use organization schema with aggregated reviews
      if (path === '/' || path === '/home') {
        addOrganizationSchema();
      } else {
        // Determine which location schema to use based on the path (without reviews)
        if (path.includes('greenville')) {
          addGreenvilleSchema();
        } else if (path.includes('tarboro')) {
          addTarboroSchema();
        } else {
          // Default to Rocky Mount schema for other pages
          addRockyMountSchema();
        }
      }
      
      // Add FAQ schema to services and resources pages
      if (path === '/services' || path === '/resources') {
        addFAQSchema();
      }
    }
    
    // Update robots meta tag to prevent indexing of admin pages
    updateRobotsTag(path);
    
  }, [location]);
  
  return null; // This component doesn't render anything
};

export default SEOManager;
